<template>
    <div
        class="mt-auto"
        data-prefooter
    >
        <component :is="preFooterComponent">
            <template
                v-if="preFooterDecoration"
                #prefooterDecoration
            >
                <component :is="preFooterDecoration" />
            </template>
        </component>
    </div>
</template>

<script setup>
    const { digistormSettings, appId } = storeToRefs(useGlobalStore())

    const preFooterType = computed(() => {
        return digistormSettings.value.preFooterType
    })

    const preFooterComponents = import.meta.glob('./**/pre-footer.async.vue')

    // Import custom components
    const customComponents = await import(`~/custom/${appId.value}/index.js`).catch(() => {
        return null
    })

    const preFooterDecoration = customComponents?.default?.PrefooterDecoration

    const preFooterComponent = computed(() => {
        if (customComponents?.default && preFooterType.value === 'pre-footer-custom') {
            return customComponents?.default?.PreFooter
        }

        return defineAsyncComponent(() => {
            const preFooter = preFooterComponents[`./${digistormSettings.value.preFooterType}/pre-footer.async.vue`]
            return preFooter
                ? preFooter()
                : Promise.reject(new Error(`Unknown pre-footer type: ${digistormSettings.value.preFooterType}`))
        })
    })
</script>
